// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f3b86ecb","338":"0d138fbd","453":"36999b38","629":"28b2f727"}[chunkId] + ".chunk.js";
};